import { getTokenClientes } from "../../Store/storages/AuthenticationStorage";
import { apiClientes } from "../../config/api";
import { BiometriaFacial } from "../../interfaces/entities/BiometriaFacial";


export const cadastrarBiometriaFacial = async (imageBase64: string): Promise<BiometriaFacial | null> => {
    try {
        const response = await apiClientes.post('/Beneficiario/CadastrarBiometriaFacial', { fileb64: imageBase64 }, {
            headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
        });
        return response.data;
    } catch (error: any) {
        console.log({ error });
        return error.response;
    }
};  

export const compararBiometriaFacial = async (imageBase64: string): Promise<BiometriaFacial | null> => {
    try {
        const response = await apiClientes.post('/Beneficiario/CompararBiometriaFacial', { fileb64: imageBase64 }, {
            headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
        });
        return response.data;
    } catch (error: any) {
        console.log({ error });
        return error.response;
    }
};  